import { API } from '~apis/axios/instance';
import { ResponseBase } from '~types/response';

interface Response extends ResponseBase {
  data: {
    accessToken: string;
  };
}

/**
 * 인증서 모듈 구동을 위한 access token 조회
 * @link https://bank.dev.clobe.ai/swagger-ui/index.html#/Scrape%20Authentication%20API/getScrapeAuthentication
 *
 * @returns
 */
export default function getCodefAccessToken() {
  return API.get<Response>('/api/v2/scrape/authentication');
}
